module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.registered) ? _c('section', [_c('div', {
    staticClass: "add-device"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', [_vm._v("Air Quality Data Request")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.registerData($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.email.$error, valid: _vm.$v.email.$dirty && !_vm.$v.email.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.$v.email.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.name.$error, valid: _vm.$v.name.$dirty && !_vm.$v.name.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.$v.name.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Current city or country of residence")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("File format preference")]), _vm._v(" "), _c('label', [_vm._v("Data in Excel, if feasible other formats may be accommodated.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file),
      expression: "file"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.file.$error, valid: _vm.$v.file.$dirty && !_vm.$v.file.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.file)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.file = $event.target.value
      }, _vm.$v.file.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('label', [_vm._v("If student, please mention year & field of study")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proffession),
      expression: "proffession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proffession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proffession = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "affiliation"
    }
  }, [_vm._v("University or organization affiliation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.affiliation),
      expression: "affiliation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.affiliation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.affiliation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    class: {
      error: _vm.$v.from.$error, valid: _vm.$v.from.$dirty && !_vm.$v.from.$invalid
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.from)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.from = $event.target.value
      }, _vm.$v.from.$touch]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    class: {
      error: _vm.$v.to.$error, valid: _vm.$v.to.$dirty && !_vm.$v.to.$invalid
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.to)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.to = $event.target.value
      }, _vm.$v.to.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.location.$error, valid: _vm.$v.location.$dirty && !_vm.$v.location.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.location)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.location = $event.target.value
      }, _vm.$v.location.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "usedby"
    }
  }, [_vm._v("The data will be used by:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usedby),
      expression: "usedby"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usedby)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usedby = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "usedfor"
    }
  }, [_vm._v("Data will be used for:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usedfor),
      expression: "usedfor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.usedfor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usedfor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('label', [_vm._v("Please make sure to include (a) project goals (b) how data will be applied and (c) if you would be willing to share or co-produce material with Drishti Kathmandu.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purpose),
      expression: "purpose"
    }],
    class: {
      error: _vm.$v.purpose.$error, valid: _vm.$v.purpose.$dirty && !_vm.$v.purpose.$invalid
    },
    attrs: {
      "rows": "4",
      "cols": "60"
    },
    domProps: {
      "value": (_vm.purpose)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.purpose = $event.target.value
      }, _vm.$v.purpose.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('label', [_vm._v("To follow up on how Drishti Kathmandu’s data was made more useful by your efforts")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.contact.$error, valid: _vm.$v.contact.$dirty && !_vm.$v.contact.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }, _vm.$v.contact.$touch]
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default device-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.$invalid
    }
  }, [_vm._v("submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('strong', [_vm._v("Whoops!")]), _vm._v(" " + _vm._s(_vm.inputError)), _c('br'), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v("\n                  " + _vm._s(error) + "\n              ")])
  }))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.registered) ? _c('section', {
    staticClass: "bg-color"
  }, [_vm._m(8)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "detail"
  }, [_c('p', [_vm._v(" We are happy to learn of your interest in Drishti Kathmandu's air quality data. Please fill out the form below so we can help provide you the information necessary.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email address"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "profession"
    }
  }, [_vm._v("Proffession"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "request"
    }
  }, [_vm._v("Requesting data from (mm/dd/yy) to (mm/dd/yy)"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "location"
    }
  }, [_vm._v("Requesting data from (location)"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "purpose"
    }
  }, [_vm._v("To help Drishti Kathmandu understand how the air quality data will be used, please briefly describe the purpose your data request."), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "contact"
    }
  }, [_vm._v("Preferred contact person & information"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "error-content"
  }, [_c('h2', [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v("Thank you for taking the time to reach out to Drishti Kathmandu! We intend to respond to your data request and email you the relevant file as soon as possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40899b93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataRequest.vue
// module id = 305
// module chunks = 1